import $ from 'jquery';
import browserDetect from '../browserdetect/browserdetect';

if (browserDetect.isIE) {
  $('img[data-object-fit][data-src]').each((index, elem) => {
    const image = $(elem);
    image.attr('src', image.attr('data-src'));
  });
}



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/common/js/lazyload/lazyload-object-fit-polyfill-fix.js